/**
 * Project Template Management
 * Handles template selection, upload, download, and delete for project exports
 */

import { TemplateManager } from '../common/templateManagement.js';
import { downloadFile } from '../common/util/util.js';

/**
 * Initialize project template management
 * @param {Object} table - The projects table instance (from setupExport)
 */
export function setupProjectTemplateManagement(table) {
    // Check if template management elements exist
    const selectElement = document.getElementById('project-template-select');
    if (!selectElement) return;

    // Get CSRF token
    const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]')?.value || '';

    // Initialize template manager
    const templateManager = new TemplateManager({
        apiBasePath: `${window.appPrefix || '/projects'}/api/project-templates`,
        storageKey: 'selectedProjectTemplate',
        modalId: 'project-template-modal',
        selectIds: ['project-template-select'],
        uploadInputIds: ['upload-project-template-input'],
        manageButtonIds: ['btn-manage-project-templates'],
        csrfToken: csrfToken
    });

    templateManager.init();

    // Setup export functionality
    setupProjectExport(table, templateManager);
}

/**
 * Setup export buttons functionality
 * @param {Object} table - The projects table instance
 * @param {TemplateManager} templateManager - The template manager instance
 */
function setupProjectExport(table, templateManager) {
    const pathname = window.location.pathname;
    const isProject = pathname.includes('/projects/project/');

    // Get project ID if we're on a project detail page
    let projectId = null;
    if (isProject) {
        const match = pathname.match(/\/projects\/project\/(\d+)/);
        if (match) projectId = match[1];
    }

    // Helper to get project IDs
    function getProjectIds() {
        let ids = [];
        if (projectId) {
            // Single project export
            ids = [parseInt(projectId)];
        } else if (table) {
            // Multiple projects from table
            ids = table.getIds();
            if (!ids.length && table.dataTable) {
                ids = table.dataTable.getData('active').map(row => row.id);
            }
        }
        return ids;
    }

    // Export DOCX
    const btnExport = document.getElementById('btn-export-projects');
    if (btnExport) {
        btnExport.addEventListener('click', function() {
            const select = document.getElementById('project-template-select');
            const template = select?.value;

            if (!template) {
                alert('Please select a template first');
                return;
            }

            const ids = getProjectIds();

            if (!ids.length) {
                alert('No projects to export');
                return;
            }

            if (ids.length > 100) {
                alert('Too many projects to export (limit is 100), please refine the search criteria');
                return;
            }

            const params = new URLSearchParams({
                ids: JSON.stringify(ids),
                template: template
            });

            downloadFile(`${window.appPrefix || '/projects'}/export_projects/?${params}`);
        });
    }

    // Export Excel
    const btnExportExcel = document.getElementById('btn-export-projects-excel');
    if (btnExportExcel) {
        btnExportExcel.addEventListener('click', function() {
            const ids = getProjectIds();

            if (!ids.length) {
                alert('No projects to export');
                return;
            }

            const params = new URLSearchParams({
                ids: JSON.stringify(ids),
                to_excel: 'true'
            });

            downloadFile(`${window.appPrefix || '/projects'}/export_projects/?${params}`);
        });
    }
}
